class NativeError { // extends Error {
  constructor ({ code, message }) {
    // super()
    this.code = code
    this.message = message
  }
}

class Native {
  get embedded () {
    return window.webkit !== undefined || window.android !== undefined // You can change this, write your embedded
  }

  set title (title) {
    title = title || ''
    this.perform('title', { title })
  }

  set rightBarTitle (title) {
    title = title || ''
    this.perform('rightBarTitle', { title })
  }

  _loadingCount = 0
  set $loading (value) {
    if (value) {
      this._loadingCount = this._loadingCount + 1
    } else {
      if (this._loadingCount <= 0) {
        return
      }
      this._loadingCount = this._loadingCount - 1
    }
    if (this._loadingCount === 0) {
      this.event('loading', false)
    }
    if (this._loadingCount === 1) {
      this.event('loading', true)
    }
  }
  get $loading () {
    return this._loadingCount > 0
  }

  callbacks = {}

  event (name, params) {
    let uuid = generateUUID()
    let message = {
      callbackId: uuid,
      content: params || {}
    }
    let promise = new Promise((resolve, reject) => {
      this.callbacks[uuid] = {
        callback: (res) => {
          if (res.error) {
            reject(new NativeError(res.error))
          } else {
            resolve(res)
          }
          delete this.callbacks[uuid]
        }
      }
    })
    this.perform(name, message)
    return promise
  }

  /**
   * native 側にこのイベントのハンドラがあるか。
   * アプリは利用者が更新するまで古いままなので、Web 側で足したイベントが
   * 相手側に無いことがある。無いときに黙って何もしないと、利用者からは
   * 「押しても何も起きない」としか見えない（NP-USR-BUG-007）。
   */
  supports (name) {
    if (!this.embedded) {
      return false
    }
    if (window.webkit && window.webkit.messageHandlers) {
      return Boolean(window.webkit.messageHandlers[name])
    }
    return Boolean(window.android)
  }

  /** 送れたら true。送れなかったことを呼び出し側が判断できるようにする */
  perform (name, message) {
    if (!this.embedded) {
      return false
    }
    if ((window.webkit) && window.webkit.messageHandlers[name]) {
      window.webkit.messageHandlers[name].postMessage(message)
      return true
    } else if (window.android) {
      window.android.postMessage(name, JSON.stringify(message))
      return true
    }
    console.warn('[native] ハンドラが無いため送れなかった: ' + name)
    return false
  }

  /**
   * native にセッションの後片付けとリダイレクトを依頼する。
   * ハンドラが無いとき（古いアプリ・ブラウザで開いたとき）は自分で遷移する。
   * セッションの後片付けは行われないが、2025-11 より前の挙動と同じで、
   * 「何も起きない」より良い。
   */
  requestSessionReset ({ loginId = null, requestUrl }) {
    if (this.supports('sessionResetRequestEvent')) {
      return this.event('sessionResetRequestEvent', { login_id: loginId, request_url: requestUrl })
    }
    console.warn('[native] sessionResetRequestEvent が使えないため直接遷移する: ' + requestUrl)
    window.location.href = requestUrl
    return Promise.resolve({ fallback: true })
  }

  constructor () {
    window.$native = this
  }
}

const native = new Native()

function generateUUID () {
  var d = new Date().getTime()
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16)
  })
  return uuid
}

export default {
  install (app) {
    app.config.globalProperties.$native = native
    app.provide('native', native)
  }
}
